import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./i18n";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import LanguageContextProvider from "./Components/contexts/LanguageContext";
import { BrowserRouter } from "react-router-dom";
import { loadAppConfig } from "./utilis/loadAppConfig";

async function startClient() {
  // Load restaurant config (logo, defaultImage, favicon etc.)
  await loadAppConfig();

  const root = ReactDOM.createRoot(document.getElementById("root"));

  root.render(
    <React.StrictMode>
      <LanguageContextProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </LanguageContextProvider>
    </React.StrictMode>
  );
}

startClient();

reportWebVitals();